<template>
  <div 
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;" 
    class="Kanit mx-auto bg-subpage-black2">

      <!-- Header -->
     <Header :isHeaderFixed="false" :subpageLogoColor="'white'" :isMenuBlack="false"></Header>

     <div>
       <h3 class="text-left" style="padding-top: 5%; font-size: 20px; font-weight: 700; color: #FFF; padding-left: 32px; letter-spacing: 1px;" >รางวัลของฉัน</h3>
     </div>

    <!-- Content -->
    <v-slide-x-transition leave-absolute hide-on-leave>
      <div class="px-4" style="padding-top: 20%;" v-if="!showBenefits">

        <!-- Member Card -->
        <member-card></member-card>

        <!-- Button -->
        <div style="margin-top: 64px;">
          <div class="d-flex mb-6" style="cursor: pointer;" @click="onBenefits">
            <div 
              style="width: 20%; background: #494949; height: 60px;" 
              class="d-flex align-center justify-center text-center"
            >
              <img :src="require('@/assets/images/icon-gift.png')" width="24px"/>
            </div>
            <div 
              style="width: 80%;  background: #000; height: 60px; color: #FFF; font-size: 18px;"
              class="d-flex align-center justify-center text-center"
            >
              สิทธิประโยชน์
            </div>
          </div>
          <div class="d-flex mb-6" style="cursor: pointer;" @click="changePage('accumulate')">
            <div 
              style="width: 20%; background: #494949; height: 60px;" 
              class="d-flex align-center justify-center text-center"
            >
              <img :src="require('@/assets/images/icon-coin.png')" width="32px"/>
            </div>
            <div 
              style="width: 80%;  background: #000; height: 60px; color: #FFF; font-size: 18px;"
              class="d-flex align-center justify-center text-center"
            >
              สะสมยอดซื้อ
            </div>
          </div>
        </div>
      </div>
      <!-- Show Benefits -->
      <div v-else>
        <!-- dataBenefits.length > 0 -->
        <div v-if="dataBenefits.length > 0" style="padding-top: 25%;" class="px-4">
          <BenefitsList
            :dataBenefits="dataBenefits"
            :memberType="member.member_type"
            @redeemSuccess="onRedeemSuccess"
          ></BenefitsList>
          <div style="margin-top: 32px;">
            <v-btn
              tile
              dark
              color="#000"
              @click="showBenefits = false"
              style="width: 100%; height: 48px;"
            >
              <div>
                <v-icon color="primary" left>
                  mdi-arrow-left
                </v-icon>
                <span>ย้อนกลับ</span>
              </div>
            </v-btn>
          </div>
        </div>
        <!-- dataBenefits.length == 0 -->
        <div v-else
          class="d-flex flex-column  justify-center" 
          style="padding: 0 16px; position: relative; height: 100%; height: calc(100vh - 106px);"
        >
          <div class="text-center py-6 primary--text" style="width: 100%; font-size: 18px;">
            {{ remark }}
          </div>   

          <!-- Button -->
          <div 
          style="
            position: absolute;
            bottom: 0px;
            width: 100%;
            left: 0;
            padding: 0 16px;
            padding-bottom: 16px;"
          >
            <v-btn
              tile
              dark
              color="#000"
              @click="showBenefits = false"
              style="width: 100%; height: 48px; font-size: 18px;"
            >
              ตกลง
            </v-btn>
          </div>
        </div> <!-- End !hasList -->
      </div> <!-- End Show Bebefits -->
    </v-slide-x-transition>
  </div>
</template>

<script>
  import axios from "axios";
  import Header from "@/components/Header.vue";
  import BenefitsList from "./BenefitsList.vue";
  import MemberCard from "./MemberCard.vue";
  
  export default {
    data() {
      return {
        showBenefits: false,
        hasList: true,
        dataBenefits: [],
        remark: '',
        limit: 50,
        offset: 0,
      }
    },
    components: {
      Header,
      BenefitsList,
      MemberCard
    },
    mounted() {
      this.getBenefits();
    },
    computed: {
      member() {
        return this.$store.state.member;
      },
    },
    methods: {
      getBenefits() {
        return new Promise((resolve) => {
          
          if(Object.keys(this.member).length == 0) {
            return 
          }

          var data = { 
            member_id: this.member.id,
            member_type: this.member.member_type,
            limit: this.limit, 
            offset: this.offset
          };

          this.loading = true;
          axios
            .get(this.serverUrl + "lamy/privilege", {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: data,
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                this.dataBenefits = response.data.data;

                // var memberType = this.$store.state.member.member_type;
                if(this.memberType == 'new') {
                    var remainPurchase;
                    var totalPurchase = this.member.totalPurchase;
                    var nextTier = 8500;
                    
                    remainPurchase = nextTier - totalPurchase;
                    this.remark = "ท่านยังไม่ได้รับสิทธิประโยชน์ สะสมยอดซื้ออีก "+remainPurchase+" บาท เพื่ออัพเกรดเป็น Silver Member รับสิทธิประโยชน์มากมาย";
                } else {
                  if(this.dataBenefits.length == 0) {
                    this.remark = "ไม่มีข้อมูลสิทธิประโยชน์";
                  }
                }
               
              } else {
                await this.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
                this.$liff.closeWindow();
              }
              resolve();
            });
        });
      },
      getMemberData() {
        var vm = this;
        return new Promise((resolve) => {
          var data = { 
            userid: vm.$store.state.userid, 
            pageid: vm.$route.query.pageid
          };
          axios
            .get(vm.serverUrl + "lamy/member", {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: data,
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                vm.$store.state.member = response.data.data[0];
                vm.$store.state.member.totalPurchase = response.data.all_total_purchase;

              } else if(response.data.responsecode == 204) {
                this.$router.push({
                  path: 'home',
                  query: {...this.$route.query } ,
                });
              } else {
                await vm.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
                vm.$liff.closeWindow();
              }
              resolve();
            });
        });
      },
      onBenefits() {
        this.showBenefits = true;
        
      },  
      onRedeemSuccess() {
        this.dataBenefits = [];
        this.getBenefits();
        this.onBenefits();
        
      },
      changePage(name) {
        var path = "/"+name;
        if (this.$route.path !== path) {
          this.$router.push({
            path: name,
            query: {...this.$route.query } ,
          }).catch({});
        }
      },
    },
    watch : {
      member(newval,oldval) {
        if(newval != oldval) {
          this.getBenefits();
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>